import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3Icon, SettingsIcon, TrendingUpIcon, MonitorIcon } from 'lucide-react';
import { whatWeDo } from '../data/home';
const iconMap = {
  chart: BarChart3Icon,
  settings: SettingsIcon,
  trending: TrendingUpIcon,
  monitor: MonitorIcon
};
export function WhatWeDoSection() {
  return <section className="bg-stark-white py-24 md:py-32" data-id="element-220" data-mp="3twscox5n1k50">
      <div className="max-w-7xl mx-auto px-6" data-id="element-221" data-mp="cgskn1z65irf">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl mb-16 space-y-5" data-id="element-222" data-mp="cjoikqb0o7fv">
          <span className="text-royal-blue text-xs font-bold uppercase tracking-[0.2em]" data-id="element-223" data-mp="2naocf1oj1so3">
            What We Do
          </span>
          <h2 className="text-midnight-navy text-3xl md:text-5xl font-montserrat font-extrabold leading-tight tracking-tight" data-id="element-224" data-mp="2j9uo4776abuo">
            Executive expertise, operational strategy, and technology in one
            platform.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-225" data-mp="vz9d7dgw3ghp">
          {whatWeDo.map((item, idx) => {
          const Icon = iconMap[item.icon as keyof typeof iconMap];
          return <motion.article key={item.title} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.08,
            ease: 'easeOut'
          }} whileHover={{
            y: -6
          }} className="group p-8 bg-stark-white border border-midnight-navy/10 rounded-2xl hover:border-royal-blue/40 hover:shadow-xl hover:shadow-midnight-navy/5 transition-all" data-id="element-226" data-mp="15okewf1g5ivk" data-mpi={idx}>
                <div className="w-12 h-12 rounded-2xl bg-royal-blue/10 text-royal-blue flex items-center justify-center mb-8 group-hover:bg-royal-blue group-hover:text-stark-white transition-colors" data-id="element-227" data-mp="3nehtp0mejgwi">
                  <Icon className="w-6 h-6" data-id="element-228" data-mp="8qweqwh0i0a" />
                </div>
                <h3 className="text-midnight-navy text-xl font-montserrat font-bold mb-3" data-id="element-229" data-mp="6w8d3pwk9rz">
                  {item.title}
                </h3>
                <p className="text-midnight-navy font-semibold mb-3" data-id="element-230" data-mp="9y0ldxw0pkk6">
                  {item.description}
                </p>
                <p className="text-midnight-navy/50 text-sm leading-relaxed" data-id="element-231" data-mp="50ijuskby7m7">
                  {item.detail}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}